export default "__VITE_ASSET__CHXQWjE0__"